import React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Link from "@mui/material/Link";
import Logo from "../Logo";

function Header() {
  return (
    <Box>
      <AppBar position="sticky" sx={{ backgroundColor: "background.default", boxShadow: "none" }}>
        <Toolbar sx={{width: '90%'}}>
          <Link href="/">
            <Logo />
          </Link>
        </Toolbar>
      </AppBar>
    </Box>
  );
}

export default Header;
